import { render, staticRenderFns } from "./PageDaySkeleton.vue?vue&type=template&id=7bb2cf5b&scoped=true"
import script from "./PageDaySkeleton.vue?vue&type=script&lang=js"
export * from "./PageDaySkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageDaySkeleton.vue?vue&type=style&index=0&id=7bb2cf5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb2cf5b",
  null
  
)

export default component.exports